import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

export const getPayoutMethodRequirementName = (
  requirement: IRequirementResponse
) => requirement.name || "Payout Method";
